(function () {
  function initProtectionPlan() {
    var protectionBoxes = document.querySelectorAll(
      '[data-camplux-protection-plan]'
    );

    if (!protectionBoxes.length) return;

    protectionBoxes.forEach(function (protectionBox) {
      if (protectionBox.dataset.initialized === 'true') return;

      protectionBox.dataset.initialized = 'true';

      var optionButtons = protectionBox.querySelectorAll(
        '.camplux-protection-option'
      );

      var variantInput = protectionBox.querySelector(
        'input[name="camplux_protection_variant_id"]'
      );

      var nameInput = protectionBox.querySelector(
        'input[name="camplux_protection_name"]'
      );

      var addToCartInput = protectionBox.querySelector(
        'input[name="camplux_protection_add_to_cart"]'
      );

      protectionBox.addEventListener('click', function (event) {
        var button = event.target.closest(
          '.camplux-protection-option'
        );

        if (!button || !protectionBox.contains(button)) return;
        if (button.classList.contains('is-active')) return;

        optionButtons.forEach(function (item) {
          item.classList.remove('is-active');
          item.setAttribute('aria-pressed', 'false');
        });

        button.classList.add('is-active');
        button.setAttribute('aria-pressed', 'true');

        var shouldAddToCart =
          button.getAttribute('data-protection-add-to-cart') === 'true';

        var selectedVariantId =
          button.getAttribute('data-protection-variant-id') || '';

        var selectedName =
          button.getAttribute('data-protection-name') || '';

        /*
         * 只有2年和3年延保才保存Variant ID。
         * 1年免费保修会把Variant ID清空。
         */
        if (variantInput) {
          variantInput.value = shouldAddToCart
            ? selectedVariantId
            : '';
        }

        if (nameInput) {
          nameInput.value = selectedName;
        }

        if (addToCartInput) {
          addToCartInput.value = shouldAddToCart
            ? 'true'
            : 'false';
        }
      });
    });
  }

  async function addItemsToCart(items) {
    var response = await fetch(
      window.Shopify && window.Shopify.routes
        ? window.Shopify.routes.root + 'cart/add.js'
        : '/cart/add.js',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: items
        })
      }
    );

    if (!response.ok) {
      var errorData;

      try {
        errorData = await response.json();
      } catch (error) {
        errorData = null;
      }

      var errorMessage =
        errorData &&
        (errorData.description ||
          errorData.message ||
          errorData.status);

      throw new Error(
        errorMessage || 'Add to cart failed'
      );
    }

    return response.json();
  }

  function getQuantity(form) {
    var quantityInput = form.querySelector(
      '[name="quantity"]'
    );

    var quantity = quantityInput
      ? parseInt(quantityInput.value, 10)
      : 1;

    return quantity && quantity > 0 ? quantity : 1;
  }

  function getMainVariantId(form) {
    var formData = new FormData(form);
    var variantId = formData.get('id');

    if (variantId) {
      return variantId;
    }

    var variantInput = form.querySelector('[name="id"]');

    return variantInput ? variantInput.value : '';
  }

  function initAddToCartIntercept() {
    if (window.__campluxProtectionSubmitReady) return;

    window.__campluxProtectionSubmitReady = true;

    document.addEventListener(
      'submit',
      async function (event) {
        var form = event.target;

        if (
          !form ||
          !form.matches('form[action*="/cart/add"]')
        ) {
          return;
        }

        var protectionBox = document.querySelector(
          '[data-camplux-protection-plan]'
        );

        if (!protectionBox) return;

        var protectionVariantInput =
          protectionBox.querySelector(
            'input[name="camplux_protection_variant_id"]'
          );

        var protectionNameInput =
          protectionBox.querySelector(
            'input[name="camplux_protection_name"]'
          );

        var protectionAddToCartInput =
          protectionBox.querySelector(
            'input[name="camplux_protection_add_to_cart"]'
          );

        var protectionVariantId =
          protectionVariantInput
            ? protectionVariantInput.value
            : '';

        var protectionName =
          protectionNameInput
            ? protectionNameInput.value
            : '';

        var shouldAddProtection =
          protectionAddToCartInput &&
          protectionAddToCartInput.value === 'true';

        /*
         * 默认1年免费保修：
         * 不拦截主题原本的Add to cart行为，
         * 让Shopify正常只加入主产品。
         */
        if (
          !shouldAddProtection ||
          !protectionVariantId
        ) {
          return;
        }

        /*
         * 只有用户选择2年或3年时，
         * 才阻止原本提交并一次加入主产品和延保产品。
         */
        event.preventDefault();
        event.stopPropagation();

        if (event.stopImmediatePropagation) {
          event.stopImmediatePropagation();
        }

        var mainVariantId = getMainVariantId(form);
        var quantity = getQuantity(form);

        var productTitle =
          protectionBox.getAttribute(
            'data-product-title'
          ) || document.title;

        if (!mainVariantId) {
          alert(
            'Please select a product option first.'
          );
          return;
        }

        var submitButton = form.querySelector(
          '[type="submit"], button[name="add"]'
        );

        var oldButtonText = '';

        if (submitButton) {
          oldButtonText = submitButton.innerHTML;
          submitButton.disabled = true;
          submitButton.innerHTML = 'Adding...';
          submitButton.setAttribute(
            'aria-busy',
            'true'
          );
        }

        var items = [
          {
            id: Number(mainVariantId),
            quantity: quantity
          },
          {
            id: Number(protectionVariantId),
            quantity: quantity,
            properties: {
              'Protection Plan': protectionName,
              'Protection For': productTitle,
              '_Main Product Variant ID':
                String(mainVariantId)
            }
          }
        ];

        try {
          await addItemsToCart(items);

          window.location.href =
            window.Shopify &&
            window.Shopify.routes
              ? window.Shopify.routes.root + 'cart'
              : '/cart';
        } catch (error) {
          console.error(
            'Camplux protection plan error:',
            error
          );

          alert(
            'The protection plan could not be added. Please try again.'
          );

          if (submitButton) {
            submitButton.disabled = false;
            submitButton.innerHTML =
              oldButtonText || 'Add to cart';

            submitButton.removeAttribute(
              'aria-busy'
            );
          }
        }
      },
      true
    );
  }

  function initializeCampluxProtectionPlan() {
    initProtectionPlan();
    initAddToCartIntercept();
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeCampluxProtectionPlan
    );
  } else {
    initializeCampluxProtectionPlan();
  }

  document.addEventListener(
    'shopify:section:load',
    function () {
      initProtectionPlan();
      initAddToCartIntercept();
    }
  );
})();